import React, { useState } from "react";
import {
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Gmail from "../Images/gmail.png";
import instagram from "../Images/instagram.png";
import Facebook from "../Images/facebook.png";
import WhatsApp from "../Images/apple.png";

import { Link } from "react-router-dom";

const DrawerComp = () => {
  const [openDrawer, setOpenDrawer] = useState(false);

  const [anchorElServices, setAnchorElServices] = useState(null);

  const handleServicesClick = (event) => {
    setAnchorElServices(event.currentTarget);
  };

  const handleServicesClose = () => {
    setAnchorElServices(null);
  };

  return (
    <React.Fragment>
      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        PaperProps={{
          sx: {
            width: 280,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            backgroundColor: "#f8f9fa",
            color: "#333",
            boxShadow: "0px 0px 20px rgba(0,0,0,0.1)",
          },
        }}
      >
        <List sx={{ paddingTop: 0 }}>
          <ListItemButton
            component={Link}
            to="/"
            onClick={() => setOpenDrawer(false)}
            sx={{
              borderBottom: "1px solid #e0e0e0",
              "&:hover": {
                backgroundColor: "#e3f2fd",
              },
            }}
          >
            <ListItemText
              primary={"Home"}
              primaryTypographyProps={{
                sx: {
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#333",
                },
              }}
            />
          </ListItemButton>

          {/* Services Dropdown */}
          <ListItemButton
            onClick={handleServicesClick}
            sx={{
              borderBottom: "1px solid #e0e0e0",
              "&:hover": {
                backgroundColor: "#e3f2fd",
              },
            }}
          >
            <ListItemText
              primary={"Services"}
              primaryTypographyProps={{
                sx: {
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#333",
                },
              }}
            />
            <ExpandMoreIcon sx={{ color: "#555" }} />
          </ListItemButton>

          <Menu
            anchorEl={anchorElServices}
            open={Boolean(anchorElServices)}
            onClose={handleServicesClose}
            PaperProps={{
              sx: {
                width: 240,
                marginLeft: "10px",
                boxShadow: "0px 4px 20px rgba(0,0,0,0.15)",
              },
            }}
          >
            <MenuItem
              component={Link}
              to="/Wholesale_Distribution"
              onClick={handleServicesClose}
              sx={{
                fontSize: "14px",
                padding: "10px 16px",
                "&:hover": {
                  backgroundColor: "#e3f2fd",
                },
              }}
            >
              Wholesale Distribution
            </MenuItem>
            <MenuItem
              component={Link}
              to="/Export_Services"
              onClick={handleServicesClose}
              sx={{
                fontSize: "14px",
                padding: "10px 16px",
                "&:hover": {
                  backgroundColor: "#e3f2fd",
                },
              }}
            >
              Export Services
            </MenuItem>
            {/* <MenuItem
              component={Link}
              to="/International_Transportation"
              onClick={handleServicesClose}
              sx={{
                fontSize: "14px",
                padding: "10px 16px",
                "&:hover": {
                  backgroundColor: "#e3f2fd",
                },
              }}
            >
              International Transportation
            </MenuItem> */}
            <MenuItem
              component={Link}
              to="/Logistics_Storage_Solutions"
              onClick={handleServicesClose}
              sx={{
                fontSize: "14px",
                padding: "10px 16px",
                "&:hover": {
                  backgroundColor: "#e3f2fd",
                },
              }}
            >
              Logistics & Storage Solutions
            </MenuItem>
            <MenuItem
              component={Link}
              to="/Customs_Clearance"
              onClick={handleServicesClose}
              sx={{
                fontSize: "14px",
                padding: "10px 16px",
                "&:hover": {
                  backgroundColor: "#e3f2fd",
                },
              }}
            >
              Customs Clearance
            </MenuItem>
          </Menu>

          <ListItemButton
            component={Link}
            to="/AboutUs"
            onClick={() => setOpenDrawer(false)}
            sx={{
              borderBottom: "1px solid #e0e0e0",
              "&:hover": {
                backgroundColor: "#e3f2fd",
              },
            }}
          >
            <ListItemText
              primary={"About Us"}
              primaryTypographyProps={{
                sx: {
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#333",
                },
              }}
            />
          </ListItemButton>
        </List>

        {/* Social Media Links */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            padding: "16px",
            backgroundColor: "#f0f0f0",
            borderTop: "1px solid #e0e0e0",
          }}
        >
          {[
            {
              icon: instagram,
              url: "https://www.instagram.com/uk_to_mars?igsh=cjViOWRuN3owcHJp&utm_source=qr",
            },
            {
              icon: Facebook,
              url: "https://www.facebook.com/share/15wM7LKkfg/?mibextid=LQQJ4d",
            },
            { icon: Gmail, url: "mailto:info@uktomars.co.uk" },
            { icon: WhatsApp, url: "http://wa.me/447564627910" },
          ].map((social, index) => (
            <IconButton
              key={index}
              onClick={() => window.open(social.url, "_blank")}
              sx={{
                margin: "0 8px",
                transition: "transform 0.3s ease",
                "&:hover": {
                  transform: "scale(1.2)",
                  backgroundColor: "transparent",
                },
              }}
            >
              <img
                src={social.icon}
                alt="Social media icon"
                style={{
                  height: "24px",
                  width: "24px",
                  filter: "grayscale(30%)",
                  transition: "filter 0.3s ease",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.filter = "grayscale(0%)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.filter = "grayscale(30%)")
                }
              />
            </IconButton>
          ))}
        </Box>
      </Drawer>

      {/* Hamburger menu button */}
      <IconButton
        onClick={() => setOpenDrawer(!openDrawer)}
        sx={{
          marginLeft: "auto",
          padding: "12px",
          color: "#ffffff",
          backgroundColor: "#555453",
          borderRadius: "8px",
          transition: "all 0.3s ease",
          "&:hover": {
            backgroundColor: "#444",
            transform: "scale(1.1)",
          },
        }}
      >
        <MenuIcon fontSize="medium" />
      </IconButton>
    </React.Fragment>
  );
};

export default DrawerComp;
